import { render, staticRenderFns } from "./uploadFile.vue?vue&type=template&id=51cbb6e6&scoped=true"
import script from "./uploadFile.vue?vue&type=script&lang=js"
export * from "./uploadFile.vue?vue&type=script&lang=js"
import style0 from "./uploadFile.vue?vue&type=style&index=0&id=51cbb6e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cbb6e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51cbb6e6')) {
      api.createRecord('51cbb6e6', component.options)
    } else {
      api.reload('51cbb6e6', component.options)
    }
    module.hot.accept("./uploadFile.vue?vue&type=template&id=51cbb6e6&scoped=true", function () {
      api.rerender('51cbb6e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/temporaryWorkerAccount/cmp/uploadFile.vue"
export default component.exports